import { render, staticRenderFns } from "./catalog-list-page.vue?vue&type=template&id=672707e2&"
import script from "./catalog-list-page.vue?vue&type=script&lang=ts&"
export * from "./catalog-list-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports